
import { Component, Vue, Prop } from 'vue-property-decorator'
import { MemberIVO } from './vo/join.vo'

@Component
export default class JoinComplete extends Vue{
  @Prop() openId!: string;
  //data

  //computed

  //method
  joinComplete(): void {
    const memberIVO: MemberIVO = {} as MemberIVO;
    memberIVO.openId = this.openId;
  }

  //initialized events
}
